<div class="container-fluid">
  <h4>{{'SupportingDocs.header' | translate}}</h4>
  <div class="row">
    <mat-form-field class="col-12">
      <mat-label>{{'SupportingDocs.lblMarket' | translate}}</mat-label>
      <mat-select>
        @for (market of markets; track market) {
          <mat-option [value]="market.id" (click)="OnChangeMarket(market.id)">
            {{market.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (isSelectedMarket) {
    <div [@slider]="isSelectedMarket? 'show' : null" class="slider">
      <p>{{'SupportingDocs.lblDescription' | translate}}</p>
      <div class="row">
        <mat-form-field class="col-12">
          <mat-label>{{'SupportingDocs.lblSpreadsheet' | translate}}</mat-label>
          <input matInput type="text" readonly [(ngModel)]="filename" [ngModelOptions]="{standalone: true}" />
          <input [hidden]="true" #spreadsheetInput type="file" (click)="spreadsheetInput.value=null" (change)="spreadsheetInputChange($event)" accept=".xls,.xlsx"/>
          <button matSuffix mat-flat-button (click)="spreadsheetInput.click()">{{'SupportingDocs.btnSelect' | translate}}</button>
        </mat-form-field>
      </div>
      <div style="display: flow-root;" class="mt-2">
        <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnClickSubmit()">{{'btnSubmit' |
        translate}}</button>
      </div>
      <div class="mt-4">
        <h6>{{'SupportingDocs.lblLatestSubmissions' | translate}}</h6>
        @if (latestSubmissions.length > 0) {
          <div>
            <ul>
              @for (submission of latestSubmissions; track submission) {
                <li style="list-style-type: none;">
                  <span class="clickable" style=" color: blue;" (click)="OnClickSpreadsheet(submission)">
                    <i style="font-size: 1em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true"></i>&nbsp; <u>{{submission.fileName}}</u>
                  </span> {{submission.date}}
                </li>
              }
            </ul>
            <p>{{'SupportingDocs.lblLatestDescription' | translate}}</p>
          </div>
        }
        @if (latestSubmissions.length === 0) {
          <div>
            {{'SupportingDocs.lblNoLatestDocs' | translate}}
          </div>
        }
      </div>
    </div>
  }
</div>